import { action, computed, makeObservable, observable } from "mobx";
import { DeviceSize } from "constants/deviceSize";
import { Theme, ThemeName } from "types/theme";
import { palette as paletteLight } from "theme/light/palette";
import { palette as paletteDark } from "theme/dark/palette";
import { typography as typographyLight } from "theme/light/typography";
import { typography as typographyDark } from "theme/dark/typography";

const localStorageTheme = window.localStorage.getItem("theme") as ThemeName;
const defaultTheme = localStorageTheme === ThemeName.Dark ? localStorageTheme : ThemeName.Light;

class ThemeStore {
  @observable private themeName: ThemeName = defaultTheme;
  @observable private themes: Record<ThemeName, Theme> = {
    [ThemeName.Light]: {
      name: ThemeName.Light,
      breakpoints: DeviceSize,
      palette: paletteLight,
      typography: typographyLight,
    },
    [ThemeName.Dark]: {
      name: ThemeName.Dark,
      breakpoints: DeviceSize,
      palette: paletteDark,
      typography: typographyDark,
    },
  };

  constructor() {
    makeObservable(this);
  }

  @computed
  public get activeThemeName() {
    return this.themeName;
  }

  @computed
  public get activeTheme() {
    return this.themes[this.themeName];
  }

  @action
  public setTheme = async (theme: ThemeName) => {
    this.themeName = theme;
    window.localStorage.setItem("theme", theme);
  };
}

export default new ThemeStore();
